import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PixabayImagesService } from '../../../services/pixabay/pixabay-images.service';

@Component({
  selector: 'app-search-pixabay-picture-modal',
  templateUrl: './search-pixabay-picture-modal.component.html',
  styleUrls: ['./search-pixabay-picture-modal.component.scss'],
})
export class SearchPixabayPictureModalComponent {
  public searchText = '';
  public pixabay_images: any = null;
  public selectedImage = null;
  public searchInProgress = false;

  constructor(
    public activeModal: NgbActiveModal,
    private pixabayImagesService: PixabayImagesService,
  ) {}

  setSearchText(text) {
    this.searchText = text;
    this.search();
  }

  selectImage(image) {
    this.selectedImage = image;
  }

  search() {
    this.searchInProgress = true;
    this.pixabayImagesService.find_images({ query: this.searchText }).subscribe(
      images => {
        this.pixabay_images = images;
        this.searchInProgress = false;
      },
      () => {
        this.searchInProgress = false;
      },
    );
  }

  onConfirm() {
    this.activeModal.close(this.selectedImage['url_sm']);
  }

  onCancel() {
    this.activeModal.close();
  }
}
